import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import { AgentFormState } from "../../../types/agentTypes";
import { FieldColumn, FieldRow, Section, SectionTitle } from "../styles";

type ContactsSectionProps = {
  formData: AgentFormState;
  techOnly: boolean;
  setFormData: React.Dispatch<React.SetStateAction<AgentFormState>>;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
};

const ContactsSection = ({
  formData,
  techOnly,
  setFormData,
  onChange,
}: ContactsSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t("createAgent.contacts.title")}</SectionTitle>

      <FieldRow>
        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.contacts.email")}
            name="email"
            value={formData.email ?? ""}
            fullWidth
            required
            onChange={onChange}
            type="email"
          />
        </FieldColumn>

        {!techOnly && (
          <FieldColumn>
            <TextField
              size="small"
              label={t("createAgent.contacts.phone")}
              name="phone"
              value={formData.phone ?? ""}
              fullWidth
              required
              onChange={(event: ChangeEvent<HTMLInputElement>) => {
                const value = event.target.value;
                const numbersOnly = value.replace(/\D/g, "");

                setFormData((prev) => ({
                  ...prev,
                  phone: numbersOnly,
                }));
              }}
            />
          </FieldColumn>
        )}
      </FieldRow>
    </Section>
  );
};

export default ContactsSection;
